module.exports = __webpack_public_path__ + "img/TGHLogoWordmarkBlue.b772316f.png";